import React, { ReactNode } from 'react';
import { CheckIcon, DiamondIcon } from './HomeschoolComp';
import { motion } from 'framer-motion';

const HomeschoolSection5 = () => {
  return (
    <div className="flex flex-col items-center rounded-t-3xl bg-[#ffd973] p-4 py-20 md:p-10">
      <section className="flex flex-col items-center text-3xl font-bold text-white drop-shadow-[2px_2px_2px_rgba(0,0,0,0.2)]">
        <DiamondIcon color="white" width={24} />
        <div className="mt-2 text-center">
          젭스영어교실
          <br />
          코스 TIP
        </div>
      </section>
      <section className="mt-10 flex flex-col gap-4">
        <Card textArr={['아직 영어 노출 전인 미취학 아이라면, KIDS 추천!']}>
          <div className="mt-4 flex flex-col gap-2 rounded-lg bg-gray1 p-4 text-sm">
            <div className="relative flex">
              <span className="mr-1 font-bold text-[#ff3f00]">KIDS</span> 2년
              <Progress type="kids" />
            </div>
            <div className="relative flex">
              <span className="mr-1 font-bold text-[#ff9b00]">BASIC</span> 4년
              <Progress type="basic" />
            </div>
            <div className="relative flex">
              <span className="mr-1 font-bold text-[#309c5b]">ADVANCED</span>{' '}
              2년
              <Progress type="advanced" />
            </div>
          </div>
        </Card>
        <Card textArr={['8세 이상이라면, 무조건 BASIC 추천!']} />
        <Card textArr={['우리말이 빠른 미취학 아동이라면, BASIC 추천!']} />
        <Card textArr={['ADVANCED는 중학생 이상, 성인까지도 가능!']} />
      </section>
    </div>
  );
};

const Progress = ({ type }: { type: 'kids' | 'basic' | 'advanced' }) => {
  return (
    <div className="absolute right-0 top-0 flex w-[180px]">
      <span
        className="h-5 grow"
        style={{ backgroundColor: type === 'kids' && '#ff3f00' }}
      />
      <span
        className="grow-[2]"
        style={{ backgroundColor: type === 'basic' && '#ff9b00' }}
      />
      <span
        className="grow"
        style={{ backgroundColor: type === 'advanced' && '#309c5b' }}
      />
    </div>
  );
};

const Card = ({
  textArr,
  children,
}: {
  textArr: string[];
  children?: ReactNode;
}) => {
  return (
    <motion.div
      className="flex flex-col rounded-xl bg-white p-4 font-medium shadow-lg"
      initial={{ x: -20 }}
      whileInView={{ x: 0 }}
    >
      <div className="flex items-start gap-2">
        <CheckIcon width={20} />
        <div className="text-sm">
          {textArr.map((text, idx) => (
            <div key={idx}>{text}</div>
          ))}
        </div>
      </div>
      {children}
    </motion.div>
  );
};

export default HomeschoolSection5;
